import { Text, View } from '@react-pdf/renderer';

import { useTranslation } from 'react-i18next';

/**
 *
 * @exports DocumentSeller
 *
 * @description Document seller component. Shows company (LegalData) and bank accounts (BankAccount) like admin invoice.
 *
 * @param { Object } props.contacts
 * @param { Object } props.legalData - LegalData with legalEntityName, registrationNumber, legalAddress, factualAddress, bankAccounts[]
 * @param { string } props.invoiceNumber - Payment reference
 *
 */

export default function DocumentSeller ( { contacts, legalData, invoiceNumber } ) {

    const { t } = useTranslation ();
    const companyName = legalData?.legalEntityName || contacts?.requisites?.company_name || "Tireshop SIA";
    const regNr = legalData?.registrationNumber || contacts?.requisites?.reg_no || "-";
    const address = legalData?.legalAddress || legalData?.factualAddress || contacts?.requisites?.legal_address || "-";
    const enabledBankAccounts = legalData?.bankAccounts?.filter ( acc => acc.isEnabled ) || [];

    return (

        <View style={ { gap: 5 } }>

            <View>
                <Text style={ { fontWeight: 500 } }>{ t ( "invoice_seller" ) }:</Text>
            </View>

            <View>
                <Text>{ companyName }</Text>
                <Text>{ t ( "reg_no" ) }: { regNr }</Text>
                <Text>{ t ( "invoice_pvn_reg_nr" ) }: LV{ regNr }</Text>
                <Text>{ address }</Text>
            </View>

            <View>
                <Text style={ { fontWeight: 500, marginBottom: 3 } }>{ t ( "requisites" ) }:</Text>
                { enabledBankAccounts.length > 0 ? (
                    enabledBankAccounts.map ( ( account, index ) => (
                        <View key={ account.id || index } style={ { marginBottom: 4 } }>
                            <Text>{ t ( "invoice_bank_name" ) }: { account.bankName }</Text>
                            <Text>{ t ( "invoice_account" ) }: { account.iban }</Text>
                            { account.swiftCode ? <Text>{ t ( "swift" ) }: { account.swiftCode }</Text> : null }
                        </View>
                    ) )
                ) : (
                    <>
                        <Text>{ t ( "invoice_bank_name" ) }: { legalData?.bankName || contacts?.requisites?.bank || "-" }</Text>
                        <Text>{ t ( "invoice_account" ) }: { legalData?.accountNumber || contacts?.requisites?.bank_account_number || "-" }</Text>
                    </>
                ) }
                { invoiceNumber ? (
                    <Text style={ { marginTop: 4, fontWeight: 500 } }>{ t ( "invoice_payment_reference" ) }: #{ invoiceNumber }</Text>
                ) : null }
            </View>

        </View>

    );

};